export const mockVolunteerOpportunities = [
  {
    id: "1",
    title: "د زده کړې پروګرام همغږی کوونکی",
    commitment: "هفته‌وار",
    location: "لرې پرتې",
    category: "Education",
    description: "زموږ د نجونو د زده کړې نوښت په همغږۍ کې مرسته وکړئ — د شریکو ښوونځیو سره اړیکې اداره کړئ، د زده کوونکو پرمختګ تعقیب کړئ، او راپورونه چمتو کړئ.",
    skills: ["ارتباطات", "تنظیم", "MS Office"],
    spots: 3,
  },
  {
    id: "2",
    title: "پښتو / دري ژباړن",
    commitment: "انعطاف منونکی",
    location: "لرې پرتې",
    category: "Language",
    description: "زموږ د دوه ژبو عملیاتو ملاتړ لپاره د انګلیسي او پښتو یا دري ترمنځ اسناد، ویب پاڼه محتوا او اړیکې وژباړئ.",
    skills: ["پښتو یا دري", "انګلیسي", "توضیحاتو ته پاملرنه"],
    spots: 5,
  },
  {
    id: "3",
    title: "د تمویل راټولولو او پیښو رضاکار",
    commitment: "میاشتنی",
    location: "ټورنټو / اوټاوا",
    category: "Fundraising",
    description: "په کاناډا کې د تمویل راټولولو پیښو، مرسته کوونکو ته د لاسرسي کمپاینونو او ټولنیز پوهاوي فعالیتونو پلان او اجرا کې مرسته.",
    skills: ["پیښې پلان کول", "ټولنیزې رسنۍ", "شبکه جوړول"],
    spots: 8,
  },
  {
    id: "4",
    title: "ټولنیزې رسنۍ او محتوا جوړونکی",
    commitment: "هفته‌وار",
    location: "لرې پرتې",
    category: "Marketing",
    description: "زموږ د ټولنیزو رسنیو چینلونو لپاره په زړه پورې محتوا جوړه کړئ، بلاګ پوسټونه ولیکئ، او زموږ آنلاین حضور پراخولو کې مرسته وکړئ.",
    skills: ["ټولنیزې رسنۍ", "لیکنه", "ګرافیک ډیزاین"],
    spots: 2,
  },
  {
    id: "5",
    title: "طبي مسلکي (ساحوي)",
    commitment: "فصلي",
    location: "افغانستان (ساحوي)",
    category: "Healthcare",
    description: "د ډاکټر، نرس یا پیرامیډیک په توګه زموږ د ګرځنده روغتیايي مرکزونو ټیمونو سره یوځای شئ. په کلیوالي افغانستان کې بې وزلو ټولنو ته لومړنۍ روغتیايي خدمتونه وړاندې کړئ.",
    skills: ["طبي جواز", "لومړنۍ مرستې", "د کلتورونو ترمنځ ارتباط"],
    spots: 4,
  },
  {
    id: "6",
    title: "د مرستې لیکلو متخصص",
    commitment: "انعطاف منونکی",
    location: "لرې پرتې",
    category: "Administration",
    description: "د تمویل فرصتونه وپلټئ او د کاناډایي او نړیوالو بنسټونو څخه د مالي ملاتړ خوندي کولو لپاره قانع کوونکې مرستې وړاندیزونه ولیکئ.",
    skills: ["د مرستې لیکنه", "څیړنه", "انګلیسي لیکنه"],
    spots: 2,
  },
];

export const mockTestimonials = [
  {
    id: "1",
    name: "سارا میچل",
    role: "د زده کړې همغږۍ رضاکاره",
    duration: "۲ کاله",
    quote: "له CAF سره رضاکاري زما د ژوند تر ټولو معنی‌لرونکو تجربو څخه وه. د نجونو پر زده کړې مستقیمه اغیزه لیدل بې‌کچه ارزښتناکه ده.",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Canadian%20woman%20smiling%2C%20headshot%20portrait%2C%20warm%20natural%20lighting%2C%20clean%20background&width=100&height=100&seq=vol1&orientation=squarish",
  },
  {
    id: "2",
    name: "احمد کریمي",
    role: "پښتو ژباړن",
    duration: "۳ کاله",
    quote: "د یو افغان-کاناډایي په توګه، د CAF ماموریت کې ونډه اخیستل د خپلو ریښو ته د بېرته ورکولو په څېر احساس کوي. ټیم لېواله دی او کار واقعاً مهم دی.",
    avatar: "https://readdy.ai/api/search-image?query=Afghan%20Canadian%20man%20smiling%2C%20professional%20headshot%2C%20warm%20lighting%2C%20clean%20background&width=100&height=100&seq=vol2&orientation=squarish",
  },
  {
    id: "3",
    name: "ډاکټر پریا شرما",
    role: "طبي ساحوي رضاکاره",
    duration: "۱ کال",
    quote: "د ګرځنده روغتیايي مرکزونو پروګرام ژوند بدلونکی دی. ما هغه ناروغان معاینه کړل چې مخکې یې هیڅکله ډاکټر نه و لیدلی. CAF ناممکن ممکن کوي.",
    avatar: "https://readdy.ai/api/search-image?query=South%20Asian%20female%20doctor%20smiling%2C%20professional%20portrait%2C%20warm%20lighting%2C%20clean%20background&width=100&height=100&seq=vol3&orientation=squarish",
  },
];